import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { NotificationsLevel } from "../../../lib/enums";
import { ErrorResponse } from "../../../requests/@types";
import { route } from "../../../shim/jsbridge";
import { show } from "../../../notifications/notifications";
import api from "../api";
import { HTTP_TOO_MANY_REQUEST_STATUS_CODE } from "../consts";
import { sampleReportKeys } from "../queryKeys";

/**
 * Downloads pcaps in 7z format
 * @param hash samples hash value
 * @param analysisId analysisId for specific analysis
 * @param isNetwork fetch from network report
 * @return { downloadPcaps }
 */
const useDownloadPcaps = (
  hash: string,
  analysisId: string,
  isNetwork = false
) => {
  const downloadUrl = route(
    "api_rl_dynamic_analysis_resource_pcaps",
    [hash, analysisId],
    isNetwork ? { isNetwork } : {}
  );

  const { mutate } = useMutation<AxiosResponse<void>, ErrorResponse>({
    mutationKey: sampleReportKeys.downloadPcaps(hash, analysisId, isNetwork),
    mutationFn: () =>
      api.downloadRlSandboxReportPcaps(hash, analysisId, isNetwork),
    onSuccess: () => {
      window.location = downloadUrl;
    },
    onError: error => {
      const errorMessage =
        error?.status === HTTP_TOO_MANY_REQUEST_STATUS_CODE
          ? "Exceeding disk or memory usage, check system health status for more information."
          : "Unexpected error occurred while downloading PCAPs.";

      show({
        level: NotificationsLevel.ERROR,
        message: errorMessage
      });
    }
  });

  const downloadPcaps = () => {
    show({
      level: NotificationsLevel.SUCCESS,
      message: "PCAPs download has started..."
    });
    mutate();
  };

  return { downloadPcaps };
};

export default useDownloadPcaps;
